// componentes react bootstrap
import { Form, Button, Modal, Container, Collapse } from "react-bootstrap";
import getDatos from "../../../../services/grupos/getDatos";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Alertas from "../../../common/Alertas";

// Hooks
import { useState, useEffect } from "react";

import setDatos from "../../../../services/grupos/setDatos";
const MySwal = withReactContent(Swal);

const vigenciaAccesoAdministrador = [
  {
    admin: [
      {
        id: 1,
        title: "3 Meses",
        value: "90",
        chk: false,
      },
      {
        id: 2,
        title: "6 Meses",
        value: "180",
        chk: false,
      },
      {
        id: 3,
        title: "1 Año",
        value: "365",
        chk: false,
      },
    ],
  },
  {
    equipo: [
      {
        id: 4,
        title: "3 Meses",
        value: "90",
        chk: false,
      },
      {
        id: 5,
        title: "6 Meses",
        value: "180",
        chk: false,
      },
      {
        id: 6,
        title: "1 Año",
        value: "365",
        chk: false,
      },
    ],
  },
];

const valoresInicialesGrupos = {
  id_grupo: 0,
  nombre_grupo: "",
  descripcion: "",
  admin_select: "",
  admin_lista: [],
  vigencia_admon: "",
  equipo_select: "",
  equipo_lista: [],
  vigencia_equipo: "",
  sub_grupo_lista: [],
  sub_grupo_select: "",
  tiene_sub_grupos: false,
  nombre_sub_grupo: "",
  activo: false,
  id_usuario_creacion: 0,
  relaciones: 0,
};

export default function AdminGrupos({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  infoUser,
  setShow,
  objectEditarApp,
  setObjectEditar,
  buscar,
  permissions,
}) {
  // Load
  const [load, setLoad] = useState(false);
  const [dataAdminGrupos, setDataAdminGrupos] = useState(
    valoresInicialesGrupos
  );

  const [relacionEditar, setRelacionEditar] = useState({});

  useEffect(() => {
    if (objectEditarApp) {
      consultarDatosEditarGrupo();
      setObjectEditar(null);
    } else {
      setRadioButonsVigencias({ ...vigenciaAccesoAdministrador });
    }
  }, [objectEditarApp]);

  useEffect(() => {
    if (dataAdminGrupos.vigencia_admon != "") {
      cambiarEstadoVigencias(0, "admin", "vigencia_admon");
    }
  }, [dataAdminGrupos.vigencia_admon]);

  useEffect(() => {
    if (dataAdminGrupos.vigencia_equipo != "") {
      cambiarEstadoVigencias(1, "equipo", "vigencia_equipo");
    }
  }, [dataAdminGrupos.vigencia_equipo]);

  const [tieneSubGrupos, setTieneSubGrupos] = useState(false);
  const [botonAgregarSubGrupo, setBotonAgregarSubGrupo] = useState(true);

  const [radioButonsVigencias, setRadioButonsVigencias] = useState(
    vigenciaAccesoAdministrador
  );

  const handleChange = ({ target }) => {
    let dataAdminGruposEdit = dataAdminGrupos;
    //if (dataAdminGrupos.id_usuario_creacion == 0) {
    dataAdminGruposEdit.id_usuario_creacion = infoUser;
    //}
    if (target.name === "vigencia_equipo") {
      if (dataAdminGruposEdit.vigencia_admon === "") {
        Alertas({
          title: "",
          html: "<span>Debe seleccionar una vigencia para el administrador</span>",
          icono: "warning",
        });
      } else {
        if (
          Number(dataAdminGruposEdit.vigencia_admon) >= Number(target.value)
        ) {
          dataAdminGruposEdit[target.name] =
            target.type === "checkbox" ? target.checked : target.value;
        } else {
          Alertas({
            title: "",
            html: "<span>La vigencia del equipo debe ser igual o menor que la del administrador</span>",
            icono: "warning",
          });
        }
      }
    } else {
      dataAdminGruposEdit[target.name] =
        target.type === "checkbox" ? target.checked : target.value;
    }

    setDataAdminGrupos({
      ...dataAdminGruposEdit,
    });
  };
  async function consultarUsuarioMapgis(tipoConsulta) {
    setLoad(true);
    try {
      let datosValido = true;
      if (dataAdminGrupos.admin_select === "" && tipoConsulta === 0) {
        datosValido = false;
      } else if (dataAdminGrupos.equipo_select === "" && tipoConsulta === 1) {
        datosValido = false;
      } else if (
        dataAdminGrupos.sub_grupo_select === "" &&
        tipoConsulta === 2
      ) {
        datosValido = false;
      }
      if (datosValido) {
        if (tipoConsulta === 0) {
          const responseUsuarios = await getDatos(
            `geomed/grupos/${dataAdminGrupos.admin_select}?idUsuario=${dataAdminGrupos.id_usuario_creacion}`
          );
          if (responseUsuarios && responseUsuarios[0] !== null) {
            let dataAdminGruposcp = { ...dataAdminGrupos };
            // if (dataAdminGruposcp.admin_lista.length > 0) {
            dataAdminGruposcp.admin_lista = [
              ...new Set([
                ...dataAdminGruposcp.admin_lista,
                ...responseUsuarios,
              ]),
            ];

            const unicos = dataAdminGruposcp.admin_lista.filter(
              (item, index, self) =>
                index ===
                self.findIndex((t) => t.id_usuario === item.id_usuario)
            );

            dataAdminGruposcp.admin_lista = unicos;
            // } else {
            //   dataAdminGruposcp.admin_lista = responseUsuarios;
            // }
            dataAdminGruposcp.admin_select = "";
            setDataAdminGrupos({ ...dataAdminGruposcp });
          } else {
            Alertas({
              title: "",
              html: "<span>No se encontraron datos</span>",
              icono: "warning",
            });
          }
        } else if (tipoConsulta === 1) {
          const responseUsuarios = await getDatos(
            `geomed/grupos/${dataAdminGrupos.equipo_select}?idUsuario=${dataAdminGrupos.id_usuario_creacion}`
          );
          if (responseUsuarios.length > 0 && responseUsuarios[0] !== null) {
            let existe = dataAdminGrupos?.admin_lista.filter((itemA) =>
              responseUsuarios.some(
                (itemB) => itemA.id_usuario === itemB.id_usuario
              )
            );
            if (existe.length === 0) {
              let dataAdminGruposcp = { ...dataAdminGrupos };
              // if (dataAdminGruposcp.admin_lista.length > 0) {
              if (dataAdminGruposcp.equipo_lista === null) {
                dataAdminGruposcp.equipo_lista = [];
              }
              dataAdminGruposcp.equipo_lista = [
                ...new Set([
                  ...dataAdminGruposcp.equipo_lista,
                  ...responseUsuarios,
                ]),
              ];

              const unicos = dataAdminGruposcp.equipo_lista.filter(
                (item, index, self) =>
                  index ===
                  self.findIndex((t) => t.id_usuario === item.id_usuario)
              );

              dataAdminGruposcp.equipo_lista = unicos;
              // } else {
              //   dataAdminGruposcp.admin_lista = responseUsuarios;
              // }
              dataAdminGruposcp.equipo_select = "";
              setDataAdminGrupos({ ...dataAdminGruposcp });
            } else {
              Alertas({
                title: "",
                html: "<span>El administrador no puede ser agregado al equipo.</span>",
                icono: "warning",
              });
            }
          } else {
            Alertas({
              title: "",
              html: "<span>No se encontraron datos</span>",
              icono: "warning",
            });
          }
        } else if (tipoConsulta === 2) {
          if (dataAdminGrupos?.sub_grupo_lista?.length < 10) {
            let dataAdminGruposcp = { ...dataAdminGrupos };
            let dataSub = [
              {
                nombre: dataAdminGruposcp.sub_grupo_select,
                id: relacionEditar.id
                  ? relacionEditar.id
                  : dataAdminGruposcp.sub_grupo_lista.length,
                estado: relacionEditar.relaciones ? "2" : "1",
                relaciones: relacionEditar.relaciones
                  ? relacionEditar.relaciones
                  : [],
              },
            ];
            dataAdminGruposcp.sub_grupo_lista = [
              ...new Set([...dataAdminGruposcp.sub_grupo_lista, ...dataSub]),
            ];

            const unicos = dataAdminGruposcp.sub_grupo_lista.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.nombre === item.nombre)
            );

            dataAdminGruposcp.sub_grupo_lista = unicos;

            dataAdminGruposcp.sub_grupo_select = "";
            setDataAdminGrupos({ ...dataAdminGruposcp });
            if (dataAdminGrupos.sub_grupo_lista.length == 10) {
              setBotonAgregarSubGrupo(false);
            } else {
              setBotonAgregarSubGrupo(true);
            }
            setRelacionEditar([]);
          } else {
            setBotonAgregarSubGrupo(false);
            MySwal.fire({
              title: "",
              html: (
                <span>Ya superó el limite máximo de subgrupos posibles</span>
              ),
              icon: "warning",
              customClass: {
                confirmButton:
                  "btn-geomedellin btn-register-admin btn-accion btn btn-primary",
              },
            });
          }
        }
      } else {
        MySwal.fire({
          title: "",
          html: <span>El campo no puede estar vacío.</span>,
          icon: "warning",
          customClass: {
            confirmButton:
              "btn-geomedellin btn-register-admin btn-accion btn btn-primary",
          },
        });
      }
    } catch (err) {
      alert("Error " + err);
    } finally {
      setLoad(false);
    }
  }

  function eliminarFilaPersona(idEliminar) {
    let filtrado = dataAdminGrupos.admin_lista.filter((item) => {
      if (idEliminar != item.id_usuario) {
        return item;
      }
    });
    setDataAdminGrupos({
      ...dataAdminGrupos,
      admin_lista: filtrado,
    });
    if (dataAdminGrupos.sub_grupo_lista.length < 10) {
      setBotonAgregarSubGrupo(true);
    }
  }

  function eliminarFilaEquipo(idEliminar) {
    let filtrado = dataAdminGrupos.equipo_lista.filter((item) => {
      if (idEliminar != item.id_usuario) {
        return item;
      }
    });
    setDataAdminGrupos({
      ...dataAdminGrupos,
      equipo_lista: filtrado,
    });
  }

  function eliminarFilaSubGrupo(id, relaciones) {
    if (dataAdminGrupos.sub_grupo_lista.length <= 10) {
      setBotonAgregarSubGrupo(true);
    } else {
      setBotonAgregarSubGrupo(false);
    }
    if (relaciones == 0) {
      let filtrado = dataAdminGrupos.sub_grupo_lista.filter((item) => {
        if (id != item.id) {
          return item;
        }
      });
      setDataAdminGrupos({
        ...dataAdminGrupos,
        sub_grupo_lista: filtrado,
      });
    } else {
      Alertas({
        title: "",
        html: "<span>No se puede eliminar el subgrupo debido a que esta ya se encuentra asociado a 1 o varios modulos.</span>",
        icono: "warning",
      });
    }
  }

  function editarFilaSubGrupo(id, dataRelacionada) {
    setRelacionEditar({ ...dataRelacionada });
    let filtrado = dataAdminGrupos.sub_grupo_lista.filter((item) => {
      if (id == item.id) {
        return item.nombre;
      }
    });
    let filtradoFila = dataAdminGrupos.sub_grupo_lista.filter((item) => {
      if (id != item.id) {
        return item.nombre;
      }
    });
    let dataAdminGruposbk = { ...dataAdminGrupos };
    dataAdminGruposbk.sub_grupo_select = filtrado[0].nombre;
    dataAdminGruposbk.sub_grupo_lista = filtradoFila;
    setDataAdminGrupos({
      ...dataAdminGruposbk,
    });
  }

  async function crudGrupo() {
    setLoad(true);
    try {
      let validado = await validarCamposObligatorios();
      if (validado) {
        const respuesta = await setDatos(`geomed/grupos`, dataAdminGrupos);
        if (respuesta) {
          setDataAdminGrupos({
            ...respuesta,
          });
          Alertas({
            title: "",
            html: "<span>Grupos almacenado de manera correcta.</span>",
            icono: "success",
          });
          limpiarDatos();
        } else {
          Alertas({
            title: "",
            html: "<span>Ah ocurrido un error en el guardado de la información.</span>",
            icono: "warning",
          });
        }
      } else {
        Alertas({
          title: "",
          html: "<span>Todos los campos marcados con * son obligatorios</span>",
          icono: "warning",
        });
      }
    } catch (err) {
      alert("Error " + err);
    } finally {
      setLoad(false);
    }
  }

  async function validarCamposObligatorios() {
    if (tieneSubGrupos && dataAdminGrupos.sub_grupo_lista == 0) {
      return false;
    } else {
      if (
        !dataAdminGrupos.nombre_grupo ||
        !dataAdminGrupos.descripcion ||
        dataAdminGrupos.admin_lista.length == 0 ||
        !dataAdminGrupos.vigencia_admon ||
        !dataAdminGrupos.vigencia_equipo
      ) {
        return false;
      }
    }

    return true;
  }

  function limpiarDatos() {
    setDataAdminGrupos({ ...valoresInicialesGrupos });
    setShow(false);
    setTieneSubGrupos(false);
    setBotonAgregarSubGrupo(true);
    let vigenciaAccesoAdministradorcp = { ...vigenciaAccesoAdministrador };
    vigenciaAccesoAdministradorcp[0].admin?.map((item, i) => {
      vigenciaAccesoAdministradorcp[0].admin[i].chk = false;
    });
    vigenciaAccesoAdministradorcp[1].equipo?.map((item, i) => {
      vigenciaAccesoAdministradorcp[1].equipo[i].chk = false;
    });
    setRadioButonsVigencias({ ...vigenciaAccesoAdministradorcp });
  }

  async function consultarDatosEditarGrupo() {
    setLoad(true);
    try {
      let respuesta;
      if (permissions.superAdmin) {
        respuesta = await getDatos(
          `geomed/grupos/consultaSA/${objectEditarApp.id_grupo}`
        );
      } else {
        respuesta = await getDatos(
          `geomed/grupos/editar/${objectEditarApp.id_grupo}`
        );
      }

      if (respuesta) {
        if (respuesta.admin_lista === null) {
          respuesta.admin_lista = [];
        }
        setDataAdminGrupos({ ...respuesta });
        setTieneSubGrupos(respuesta.tiene_sub_grupos);
      }
    } catch (err) {
      alert("Error " + err);
    } finally {
      setLoad(false);
    }
  }

  function cambiarEstadoVigencias(
    posicion = 0,
    key = "admin",
    parametroFiltro = "vigencia_admon"
  ) {
    let valor = { ...radioButonsVigencias };
    valor[posicion][key].map((dato, i) => {
      if (dato.value == dataAdminGrupos[parametroFiltro]) {
        dato.chk = true;
      } else {
        dato.chk = false;
      }
    });
    setRadioButonsVigencias({ ...valor });
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        limpiarDatos();
      }}
      size="md"
      id="modalAdminRegister"
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{tituloModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="pb-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Nombre del grupo <strong>*</strong>
              </Form.Label>
              <Form.Control
                onChange={handleChange}
                type="text"
                name="nombre_grupo"
                id="nombre_grupo"
                className="inputs-forms-admin focus-admin-register"
                value={dataAdminGrupos.nombre_grupo}
                maxLength={"60"}
                disabled={!permissions.superAdmin}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Descripción <strong>*</strong>
              </Form.Label>
              <Form.Control
                name="descripcion"
                id="descripcion"
                onChange={handleChange}
                as="textarea"
                className="inputs-forms-admin focus-admin-register textarea-form-admin"
                value={dataAdminGrupos.descripcion}
                maxLength={"1000"}
                disabled={!permissions.superAdmin}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Administrador <strong>*</strong>
              </Form.Label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Form.Control
                  type={"text"}
                  id="admin_select"
                  name="admin_select"
                  className="inputs-forms-admin focus-admin-register"
                  placeholder="CC o Correo"
                  value={dataAdminGrupos.admin_select}
                  onChange={handleChange}
                  disabled={!permissions.superAdmin}
                />
                {permissions.superAdmin ? (
                  <i
                    className="icon-serch-vertical icon-serch-vertical-input"
                    onClick={() => {
                      consultarUsuarioMapgis(0);
                    }}
                  ></i>
                ) : (
                  <></>
                )}
              </div>
              <div id="contenedorListaAdmin">
                {dataAdminGrupos?.admin_lista.map((item) => {
                  return (
                    <li
                      key={item.id_usuario}
                      className="contenedor-eliminar-listas-grupos"
                    >
                      {item.nombres + " " + item.apellidos}
                      {permissions.superAdmin ? (
                        <span
                          className="icon-eliminar icono-eliminar-listas-grupos"
                          onClick={() => eliminarFilaPersona(item.id_usuario)}
                        ></span>
                      ) : (
                        <></>
                      )}
                    </li>
                  );
                })}
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label
                className="label-forms-admin"
                title="Proyecto original"
              >
                Vigencia acceso del administrador <strong>*</strong>
              </Form.Label>
              <Form.Group className={"container-vigencias-grupos"}>
                {radioButonsVigencias[0].admin.map((e, i) => {
                  return (
                    <Form.Check
                      type={"radio"}
                      key={`radio-admin-${e.id}-${i}`}
                      value={e.value}
                      name={`vigencia_admon`}
                      onChange={handleChange}
                      id={`radio-videncia-admin-${e.id}-${i}`}
                      label={`${e.title}`}
                      className={"radio-rating"}
                      checked={e.chk}
                      disabled={!permissions.superAdmin}
                    />
                  );
                })}
              </Form.Group>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Miembros del equipo
              </Form.Label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Form.Control
                  type={"text"}
                  id="equipo_select"
                  name="equipo_select"
                  className="inputs-forms-admin focus-admin-register"
                  placeholder="CC o Correo"
                  value={dataAdminGrupos.equipo_select}
                  onChange={handleChange}
                />
                <i
                  className="icon-serch-vertical icon-serch-vertical-input"
                  onClick={() => {
                    consultarUsuarioMapgis(1);
                  }}
                ></i>
              </div>
              <div id="contenedorListaAdmin">
                {dataAdminGrupos.equipo_lista?.map((item) => {
                  return (
                    <li
                      key={item.id_usuario}
                      className="contenedor-eliminar-listas-grupos"
                    >
                      {item.identificador +
                        " - " +
                        item.email +
                        " - " +
                        item.nombres +
                        " - " +
                        item.apellidos}
                      <span
                        className="icon-eliminar icono-eliminar-listas-grupos"
                        onClick={() => eliminarFilaEquipo(item.id_usuario)}
                      ></span>
                    </li>
                  );
                })}
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label
                className="label-forms-admin"
                title="Proyecto original"
              >
                Vigencia acceso del equipo <strong>*</strong>
              </Form.Label>
              <Form.Group className={"container-vigencias-grupos"}>
                {radioButonsVigencias[1].equipo.map((e, i) => {
                  return (
                    <Form.Check
                      type={"radio"}
                      key={`radio-miembros-${e.id}-${i}`}
                      value={e.value}
                      name={`vigencia_equipo`}
                      onChange={handleChange}
                      id={`radio-vigencia-miembros-${e.id}-${i}`}
                      label={`${e.title}`}
                      className={"radio-rating"}
                      checked={e.chk}
                    />
                  );
                })}
              </Form.Group>
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="container-checks-admin">
                <Form.Label className="label-forms-admin me-2" title="Activo">
                  Activo
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  //   onChange={handleChange}
                  name="activo"
                  id="activo"
                  checked={dataAdminGrupos.activo}
                  onChange={handleChange}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="container-checks-admin">
                <Form.Label className="label-forms-admin me-2" title="Activo">
                  ¿Tiene subgrupos?
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  onChange={handleChange}
                  onClick={() => {
                    setTieneSubGrupos(!tieneSubGrupos);
                  }}
                  name="tiene_sub_grupos"
                  checked={dataAdminGrupos.tiene_sub_grupos}
                />
              </div>
            </Form.Group>
            {tieneSubGrupos && (
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Nombre del subgrupo(s) <strong>*</strong>
                </Form.Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Control
                    type={"text"}
                    id="sub_grupo_select"
                    name="sub_grupo_select"
                    className="inputs-forms-admin focus-admin-register"
                    placeholder="Ingrese el nombre del subgrupo (max 10)"
                    value={dataAdminGrupos.sub_grupo_select}
                    onChange={handleChange}
                  />
                  {botonAgregarSubGrupo && (
                    <i
                      className="icon-serch-vertical icon-serch-vertical-input"
                      onClick={() => {
                        consultarUsuarioMapgis(2);
                      }}
                    ></i>
                  )}
                </div>
                <div id="contenedorListaAdmin">
                  {dataAdminGrupos.sub_grupo_lista?.map((item) => {
                    let relacionTotal = item.relaciones?.reduce(
                      (acc, item2) => acc + item2.total,
                      0
                    );
                    let relacionData = item.relaciones
                      ?.map((item2) => `${item2.relacion}: ${item2.total}`)
                      .join("\n");
                    return (
                      <li
                        key={item.id}
                        className="contenedor-eliminar-listas-grupos"
                      >
                        {`${item.nombre}`}
                        <span
                          style={{ cursor: "pointer" }}
                          title={relacionData}
                        >{`(${relacionTotal ? relacionTotal : 0})`}</span>
                        <div className="contenedor-iconos-sub-grupos">
                          <span
                            className="icon-editar icono-eliminar-listas-grupos"
                            onClick={() => editarFilaSubGrupo(item.id, item)}
                          ></span>
                          <span
                            className="icon-eliminar icono-eliminar-listas-grupos"
                            onClick={() =>
                              eliminarFilaSubGrupo(
                                item.id,
                                relacionTotal ? relacionTotal : 0
                              )
                            }
                          ></span>
                        </div>
                      </li>
                    );
                  })}
                </div>
              </Form.Group>
            )}
            <Form.Group className="container-accion-admin-button ">
              <Button
                className="btn-geomedellin btn-register-admin btn-accion"
                onClick={() => {
                  crudGrupo();
                }}
              >
                Guardar
              </Button>
            </Form.Group>
            {/* </div> */}
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
